import { ReactElement, type JSX } from "react";
import { LeftArrowIcon } from "staysure-component-library";

import LabelButtonWrapper, {
  IconButtonWrapper,
} from "@/components/atoms/button-wrapper/button-wrapper";
import withBrand from "@/components/with-brand";

type ActionButtonType = {
  disabledBtn1?: boolean;
  disabledBtn2?: boolean;
  ctaButton2Text?: string;
  onClickBtn1?: () => void;
  onClickBtn2?: () => void;
  isLoading?: boolean;
  loadingIcon?: ReactElement;
  isClickableDisabled?: boolean;
  ctaButton2Type?: "submit" | "button";
  formId?: string;
  id: string;
  brand?: "staysure" | "avanti";
  showBackBtn?: boolean;
};

function ActionButton({
  disabledBtn1 = false,
  disabledBtn2 = false,
  ctaButton2Text = "Continue",
  onClickBtn1,
  onClickBtn2,
  isLoading = false,
  loadingIcon,
  isClickableDisabled = false,
  ctaButton2Type,
  formId,
  id,
  brand,
  showBackBtn = true,
}: Readonly<ActionButtonType>): JSX.Element {
  const handleBackButtonClick = () => {
    if (typeof onClickBtn1 === "function") {
      onClickBtn1();
    }
  };

  const handleMainButtonClick = () => {
    if (typeof onClickBtn2 === "function") {
      onClickBtn2();
    }
  };

  return (
    <div
      className="flex justify-between fixed z-20 w-full bottom-0 left-0 py-spacing-s px-spacing-l md:px-0
  bg-surface-neutral-option-1
  shadow-[0_4px_4px_0px_#00000040] md:gap-x-[16px] md:fixed md:justify-center  md:bottom-0 lg:shadow-none lg:relative lg:bg-transparent gap-x-spacing-s"
      data-testid={`${id}-action-wrapper`}
    >
      {showBackBtn && (
        <IconButtonWrapper
          data-testid={`${id}-back-button`}
          id={`${id}-back-button`}
          btnType="icon"
          onClick={handleBackButtonClick}
          icon={
            <LeftArrowIcon
              brand={brand}
              stroke={disabledBtn1 ? "#D2D2D2" : undefined}
            />
          }
          hierarchy="secondary"
          isDisabled={disabledBtn1}
          className={` z-[2] relative 
          min-w-[56px] w-[56px] min-h-[56px] h-[56px] flex justify-center 
          items-center leading-[18px] ${
            disabledBtn1
              ? "!border-border-disabled bg-transparent hover:bg-transparent hover:border-transparent"
              : "hover:bg-hover-background hover:border-hover-border"
          }`}
        />
      )}

      <div className=" backdrop-blur-[1.5px] md:hidden absolute h-full w-full z-[1] top-0 right-0" />

      <LabelButtonWrapper
        data-testid={`${id}-submit-button`}
        id={`${id}-submit-button`}
        isClickableDisabled={isClickableDisabled}
        isDisabled={disabledBtn2}
        label={ctaButton2Text}
        isLoading={isLoading}
        loadingIcon={loadingIcon ?? <div />}
        hierarchy="primary"
        className="flex flex-col justify-center items-center 
         gap-grid-system-space-050 w-full z-[2] relative 
         py-spacing-s px-spacing-l md:px-0 font-body-font text-xs
         leading-[18px] font-semibold h-[56px] text-text-on-primary md:w-[244px] landscape:w-[604px]"
        form={formId}
        onClick={handleMainButtonClick}
        type={ctaButton2Type ?? "submit"}
      />
    </div>
  );
}

export default withBrand(ActionButton);
